export const getProtocol = () =>
  process.env.REACT_APP_ENV === "local" ? "http://" : "https://";
